module.exports = __webpack_public_path__ + "static/media/password-icon-visible.b89cddc3.svg";